import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppGlobals } from '@app/app.global';
import { AuthService, EntityService, PageMetaService, SharedService, User } from '@app/core';
import { HomeLayoutComponent } from '@app/layout';
import { ReportService } from '@app/modules/report/services';
import { VoucherService } from '@modules/voucher/services';
import { PriceDiscoveryService } from '@modules/price-discovery/services/price-discovery.service';
import { PmdSidebar } from '@shared/propeller';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SideBarSection } from './sidebar.section';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @ViewChild(PmdSidebar) leftSidebar: { toggleSideBar: () => void; };
  @Input() isOpen: boolean;
  // @Output() isOpenChange: EventEmitter<boolean>;
  isWithTags: any = false;
  url$: Observable<string> = new Observable<string>();
  currentURL: string;
  // profileSidebarUrl: string[] = ['/entity', '/voucher', '/user-management'];
  loggedinUser: User;
  showPushToPetpooja: boolean = false;

  // isSidebarOpen = true;
  showPushToRetailPos: boolean = false;
  showPushToTally: boolean = false;
  productTagsSubscription: Subscription;
  companyDetailsSubscription: Subscription;
  canShowBeneficiary = false;
  isLeadAdminModuleAccess: boolean = false;
  token: string;
  @ViewChild(HomeLayoutComponent) homeLayoutComponent!: HomeLayoutComponent;
  // @Output() settingsSidebarEmitter: EventEmitter<boolean> = new EventEmitter(false);
  loggedInUserThumbnail: string;

  topSections: any[] = [];
  bottomSections: any[] = [];
  activeMenu: any;
  isSettingsSidebar = false;
  sideBarSection: SideBarSection;
  canAdminViewReport = false;
  canAdminUpload = false;

  // isSubmenuOpen: { [key: string]: boolean } = { banking: false, p2poss: false, p2Invoice: false, p2Telly: false };
  constructor(private sharedService: SharedService,
    public appGlobals: AppGlobals,
    public authService: AuthService,
    private entityService: EntityService,
    private voucherService: VoucherService,
    private priceDiscoveryService: PriceDiscoveryService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private readonly pageMetaService: PageMetaService,
    private readonly reportService: ReportService
  ) {

    // this.isOpenChange = new EventEmitter<boolean>(this.isOpen);

    this.loggedinUser = this.authService.user;
    this.url$ = this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url));
    this.url$.subscribe((resp) => { this.currentURL = resp; });
  }

  ngOnInit(): void {
    this.sideBarSection = new SideBarSection(this.authService, this.appGlobals, this.sharedService);
    // * Enable lead admin module for specifc user
    const loggedinUser = this.authService.user;
    if (Array.isArray(this.appGlobals.leadAdminModuleAccessUser) && this.appGlobals.leadAdminModuleAccessUser.includes(loggedinUser.email)) {
      this.isLeadAdminModuleAccess = true;
    }

    // check if can show beneficiary module
    this.sharedService.currentKYCStatus.subscribe((response) => {
      if (response && response == this.appGlobals.KYC_STATUSES.APPROVED) {
        this.canShowBeneficiary = true;
      } else {
        this.canShowBeneficiary = false;
      }
    });

    this.entityService.currentCompanySelection$.subscribe((response) => {
      if (response) {
        this.syncHyperpureFlag(response);
        if (this.authService.user?.isOwner && !this.authService.user?.isAdmin) {
          if (this.authService.user?.isSecondaryOwner && this.authService.user?.userAccessList.includes('Payments')) {
            this.sharedService.getKYC();
          } else if (this.authService.user?.isOwner && !this.authService.user?.isSecondaryOwner) {
            this.sharedService.getKYC();
          }
        }

        if (this.authService.user?.isOwner || this.authService.user?.isOutlet) {
          this.voucherService.getCompanyList().subscribe(res => {
            if (res.length) {
              this.sharedService.setStandardGSTUOMForCompanies(res);
              res.forEach(company => {
                if (company.restaurantSyncCode && company.restaurantSyncCode !== '') {
                  if (this.authService.user.isSecondaryOwner) {
                    if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PETPOOJA_POS)) {
                      this.showPushToPetpooja = true;
                    } else {
                      this.showPushToPetpooja = false;
                    }
                  } else {
                    this.showPushToPetpooja = true;
                  }
                }

                if (company.retailPosSyncCode && company.retailPosSyncCode !== '') {
                  if (this.authService.user.isSecondaryOwner) {
                    if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PETPOOJA_INVOICE)) {
                      this.showPushToRetailPos = true;
                    } else {
                      this.showPushToRetailPos = false;
                    }
                  } else {
                    this.showPushToRetailPos = true;
                  }
                }

                if (company.tallySyncCode && company.tallySyncCode !== '') {
                  if (this.authService.user.isSecondaryOwner) {
                    if (this.authService.user.userAccessList.includes(this.appGlobals.USER_ACCESS.PUSH_TO_TALLY)) {
                      this.showPushToTally = true;
                    } else {
                      this.showPushToTally = false;
                    }
                  } else {
                    this.showPushToTally = true;
                  }
                }
              });
              this.fetchSidebarMenus();
            }
          }, (error) => {
            this.fetchSidebarMenus();
          })
        } else {
          this.showPushToPetpooja = true;
          this.showPushToRetailPos = true;
          this.showPushToTally = true;
          this.reportService.hasAdminAccess().subscribe({
            next: (response: any) => {
              if (response?.adminAccess?.canViewReports) {
                this.canAdminViewReport = true;
              }
              if (response?.adminAccess?.canUpload) {
                this.canAdminUpload = true;
              }
              this.fetchSidebarMenus();
            },
            error: (error) => {
              console.log("error", error);
              this.fetchSidebarMenus();
            }
          });

          if (this.authService.user?.isAdmin) {
            this.voucherService.getCompanyList().subscribe(res => {
              if (res.length) {
                this.sharedService.setStandardGSTUOMForCompanies(res);
              }
            }, (error) => {
              this.sharedService.errorAlert(error);
            });
          }
        }
      }
    })

    // this.sharedService.currentSideBarActive$.
    //   subscribe((response) => {
    //     if (response) {
    //       this.toggleSidebar();
    //     }
    //   })

    this.token = this.authService.token;

    this.sharedService.currentLoggedInUserThumbnail.subscribe((thumbnail) => {
      this.loggedInUserThumbnail = thumbnail;
    });

    // Subscribe to hyperpureEnabled changes to update sidebar menu
    this.sharedService.hyperpureEnabled.subscribe(() => {
      this.fetchSidebarMenus();
    });
  }
  // toggleSubmenu(menu: string): void {
  //   this.isSubmenuOpen[menu] = !this.isSubmenuOpen[menu];
  // }

  /**
   * This method will fetch dynamic menus based on the conditions
   */
  fetchSidebarMenus() {
    const roleAndIsPaidObject = {
      isAdmin: this.authService.user?.isAdmin,
      isLeadAdmin: this.authService.user?.isLeadAdmin,
      isOwner: this.authService.user?.isOwner,
      isPaidUser: this.authService.user.isPaidUser
    }

    const pushToAndBeneficiaryToggles = {
      showPushToPetpooja: this.showPushToPetpooja,
      showPushToRetailPos: this.showPushToRetailPos,
      showPushToTally: this.showPushToTally,
      showBeneficiary: this.canShowBeneficiary
    }
    this.topSections = this.sideBarSection.topSections(roleAndIsPaidObject, pushToAndBeneficiaryToggles, this.isLeadAdminModuleAccess, this.canAdminViewReport, this.canAdminUpload);

    this.bottomSections = this.sideBarSection.bottomSections(roleAndIsPaidObject, pushToAndBeneficiaryToggles);
  }

  getCompanyDetails() {
    this.voucherService.getCompanyDetails().subscribe(res => {

      if (res["restaurantSyncCode"]) {
        this.showPushToPetpooja = true;
      }

      if (res["retailPosSyncCode"]) {
        this.showPushToRetailPos = true;
      }

      if (res["tallySyncCode"]) {
        this.showPushToTally = true;
      }
    }, (error) => {
      this.sharedService.errorAlert(error)
    });
  }

  // toggleSidebar() {
  //   this.isOpen = !this.isOpen;
  //   this.isOpenChange.emit(this.isOpen);
  //   localStorage.setItem('isSidebarOpen', JSON.stringify(this.isOpen));
  //   const overlayDiv = document.getElementsByClassName('pmd-sidebar-overlay')[0];
  //   if (!this.isOpen) {
  //     overlayDiv.classList.remove('pmd-sidebar-overlay-active');
  //   }
  // }

  logout() {
    this.sharedService.resetSelectedEntityFormControl();
    if (this.token) {
      this.authService.logout(this.token);
    } else {
      this.authService.logout();
      this.sharedService.cancelAPICalls$.next();
    }
  }

  onOpenConfirmDetailModalComponent() {
    this.sharedService.isPremiumUser.next(true);
  }


  openInnerSidebar(menu: any) {
    this.activeMenu = menu;
    this.pageMetaService.activeMenu.next(menu || []);
    
    // Store the active menu to localStorage for sidebar-submenu component
    if (menu) {
      localStorage.setItem('innerActiveMenu', JSON.stringify(menu));
    }

    if (this.activeMenu.subMenus?.length > 0) {
      this.isSettingsSidebar = true;
      if (this.isSettingsSidebar) {
        localStorage.setItem('isSettingsSidebarOpen', JSON.stringify(true));
      }
    }
    else {
      localStorage.setItem('isSettingsSidebarOpen', JSON.stringify(false));
    }
  }
  closeMobileSidebar() {
    const sideBarElement = document.getElementById('leftSidebarMenu');
    if (sideBarElement) {
      document.body.classList.remove('pmd-body-open');
      // ✅ Remove the generated div
      const extraDiv = document.querySelector('.pmd-sidebar-overlay');
      if (extraDiv) {
        extraDiv.remove();
      }
      this.cdRef.detectChanges();
    }
  }
  getTrialPercent(): number {
    const remaining: any = this.authService.user?.remainingFreeTrialDays ?? 0;
    const used = 10 - remaining;
    return Math.min((used / 10) * 100, 100);
  }

  getRemainingFreeTrialDays() {
    const rawDays = this.authService.user?.remainingFreeTrialDays ?? 0;
    const days = Number(rawDays); // force conversion to number
    return isNaN(days) ? 0 : days;
  }


  ngOnDestroy(): void {
    this.productTagsSubscription?.unsubscribe();
    this.companyDetailsSubscription?.unsubscribe();
  };

  private syncHyperpureFlag(selection: any): void {
    if (!this.authService.user?.enablePurchase) {
      this.sharedService.hyperpureEnabled.next(false);
      return;
    }

    const entity = Array.isArray(selection) ? selection[0] : selection;
    const entityId = entity?.id;

    if (!entityId) {
      return;
    }

    this.priceDiscoveryService.checkHyperpureEnabled(entityId).subscribe(
      (res) => {
        const isEnabled = !!res?.isHyperpureEnabled || !!res?.hyperpureStoreUuid;
        this.sharedService.hyperpureEnabled.next(isEnabled);
      },
      () => this.sharedService.hyperpureEnabled.next(false)
    );
  }
}